import { render, staticRenderFns } from "./inventoryquantityadjustbill.vue?vue&type=template&id=2ef8b2ca&scoped=true&"
import script from "./inventoryquantityadjustbill.vue?vue&type=script&lang=js&"
export * from "./inventoryquantityadjustbill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8b2ca",
  null
  
)

export default component.exports